
<template>
  <q-expansion-item
    :data-testid="`transferencia-agente-${agent.id}`"
    dense
    v-model="openConfig"
    @before-show="loadQueues()"
    expand-icon-class="text-primary"
    style="border: 1px solid #95959587; border-radius: 4px"
    class="q-mb-xs"
    :header-class="`text-primary bordered ${openConfig? 'background-header' : ''}`"
  >
    <template #header>
      <q-item-section
        class="col-auto"
      >
        <q-icon
          name="mdi-face-agent"
          color="primary"
          size="sm"
          class="q-pa-none"
        />
      </q-item-section>

      <q-item-section class="row">
        <q-item-label>
          {{ agent.label }}
        </q-item-label>

        <q-tooltip>
          Transferir para o agente {{ agent.id }}
          <br>
          {{ agent.name }}
        </q-tooltip>
      </q-item-section>
    </template>

    <q-card class="q-mx-md">
      <q-item v-if="loadingQueues">
        <q-item-section>
          <q-spinner
            size="20px"
            color="primary"
          />
        </q-item-section>
      </q-item>

      <div v-else-if="queues?.length">
        <span class="row items-center q-my-xs text-bold">
          Selecione a Fila
        </span>
        <q-separator />
        <q-list>
          <q-item
            :data-testid="`transferencia-agente-${agent.id}-fila-${queue.queueId}`"
            dense
            v-for="queue in queues"
            :key="queue.queueId"
            clickable
            :class="['row', isAgentActive && activeQueue.queueId === queue.queueId ? 'selected-queue' : '']"
            @click="selectQueue(queue)"
          >
            <q-item-section class="col-auto">
              <q-icon name="mdi-circle-small" />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ queue.name }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </div>

      <q-item v-else>
        <q-item-section>
          <div class="row items-center">
            <div class="col">
              <q-item-label>
                Nenhuma fila encontrada
              </q-item-label>
            </div>
          </div>
        </q-item-section>
      </q-item>
    </q-card>
  </q-expansion-item>
</template>

<script>
import api from '@/libs/api'

export default {
  props: {
    agent: {},
    activeAgent: {
      default: null
    },
    activeQueue: {
      default: null
    }
  },

  data () {
    return {
      queues: [],
      openConfig: false,
      loadingQueues: false,
      selectedQueue: null

    }
  },

  computed: {
    isAgentActive () {
      return this.activeAgent?.id === this.agent?.id
    }
  },

  methods: {
    async loadQueues () {
      if (!this.agent) return
      this.loadingQueues = true
      const { rows } = await api.loadAgentQueues(this.agent.id)
      this.queues = rows
      this.loadingQueues = false
    },

    selectQueue (queue) {
      this.$emit('handle-queue-selection', { agent: this.agent, queue })
    }
  }
}
</script>

<style lang="sass">
.selected-queue
  background-color: #e0f7fa
  font-weight: bold
  .selected-queue-info
    margin-top: 1rem

.background-header
  background-color: #ebf1f6
</style>
